export const socketEvents = {
  newMessage: "newMessage",
  updateChat: "updateChat",
  messageStatusChanged: "messageStatusChanged",
};
